export const ROLE_ADMIN = 'ROLE_ADMIN'
export const ROLE_RESTAURANT = 'ROLE_RESTAURANT'
export const ROLE_COMPANY = 'ROLE_COMPANY'
export const ROLE_USER = 'ROLE_USER'
export const ROLE_EXTRA_BILLING_ACCESS = 'ROLE_EXTRA_BILLING_ACCESS'
export const ROLE_USER_PROFILE_CREATE = 'ROLE_USER_PROFILE_CREATE'
